<div class="invite-modal add-email">
  <h2>Confirm Email</h2>
  @if (allOk) {
    <div>
      @if (notAdmin()) {
        <div flex="45">
          Please confirm that you have access to:  {{ emailItem.value}} which will now be sent a validation email - please check your Spam Folder
        </div>
      }
    </div>
  } @else {
    Checking Email is available....
  }
  @if (emailErrors.length > 0) {
    <div>
      <div flex="45">
        @for (err of emailErrors; track err) {
          <ul>
            <li>{{err}}
            </ul>
          }
        </div>
      </div>
    }

    <footer>
      @if (allOk) {
        <div>
          @if (notAdmin()) {
            <div>
              <button mat-stroked-button (click)="close()">Yes I have Access</button>
              &nbsp;
              <button mat-stroked-button (click)="cancel()">Cancel</button>
            </div>
          } @else {
            <button mat-stroked-button (click)="completed()">Done</button>
          }
        </div>
      } @else {
        <button mat-stroked-button (click)="cancel()">Done</button>
      }
    </footer>
  </div>
